<script lang="ts" setup>
// TODO: maybe merge grid and favorite views together because they're similar
import tile from '@/components/grid/tile.vue';
import loader from '@/components/grid/loader/loader.vue';
import pager from '@/components/pager/pager.vue';

import { DEFAULT_LIMIT } from '@/api/performer/request';
import { usePerformerStore } from '@/stores/performer';
import { useModalsStore } from '@/stores/modals';
import { onMounted, watch, watchEffect, ref } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import router from './../../router';

const route = useRoute();
let page = ref(1);
const props = withDefaults( defineProps<{
    page: number;
    offset: number;
    limit: number;
    search?: string;
}>(), {page: 1, offset: 0, limit: DEFAULT_LIMIT} );

const store = usePerformerStore();
const { getActiveModal } = storeToRefs( useModalsStore() );
const performers = store.getSlice('favorites');
const theme = ref(import.meta.env.VITE_Themename);

watch(props, load);
watch(page, (newPage, oldPage) => {
    pageChange(newPage);
});

onMounted(load);

function load() {
    page.value = route.query.page ? parseInt(route.query.page as string) : 1;
    store.loadFavorites({ ...props });
    store.currentSlice = 'favorites';
}

function pageChange(paged: number) {
    let routeParams = {
        name: route.name!,
        query: {
            page: paged ? paged : page.value,
            offset: (paged - 1) * props.limit,
            limit: props.limit,
            search: route.query.search || undefined
        }
    };

    router.push(routeParams);
}

const shouldShowTileContent = (index: number, page: number) => {
    return false;
};
</script>

<template src="./grid.html"></template>
